/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=497b568e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=497b568e&lang=less"

import exportComponent from "/Users/sujian/Desktop/lihu/吕楠中医挂号平台/voice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__